import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import TEXT from "../../../../utils/globalText";
import ICONS from "../../../../assets/Icons";

const OwnerAccountBulkUploadStatementSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [sucessData, setSucessData] = useState([]);

  useEffect(() => {
    const data = sessionStorage.getItem("uploadStatementData");
    setSucessData(JSON.parse(data));
  }, []);

  useEffect(() => {
    dispatch(disableSwitcher());

    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(enableSwitcher());
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch, id]);

  const uploadBankStatement = () => {
    navigate("/owner_account_dashboard/upload_bulk_bank_statement");
    try {
      sessionStorage.removeItem("recreate_ben");
    } catch (error) {
      console.error(error)
    }
  };

  const dashboardHandler = () => {
    navigate("/owner_account_dashboard", { replace: true });
  };

  const buttonRows = [
    [
      {
        btnText: "Upload bank statement",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: uploadBankStatement,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "black",
      },
    ],
  ];

  return (
    <>
      <div className="mx-auto">
        <StatusContainer
          isLoading={false}
          status="success"
          hoverOption="white"
          title={"Statement is being processed"}
          subtitle="Once the data is uploaded, you will be notified by email, and it will be reflected in Xpentra’s statement."
          buttonRows={buttonRows}
        >
          <TabsWeapperSection title="Upload details">
            <>
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: formatAccountNumber(sucessData?.account_no),
                    leftSubTitle: "Bank Account Number",
                  },
                ]}
              />

              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: sucessData?.iFSC_Code,
                    leftSubTitle: TEXT?.IFSC_CODE,
                    ifsc: sucessData?.iFSC_Code,
                  },
                ]}
              />

              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle:
                      sucessData?.uploaded_file_data?.metadata?.filename,

                    leftSubTitle: "File name",
                  },
                ]}
              />
            </>
          </TabsWeapperSection>
        </StatusContainer>
      </div>
    </>
  );
};

export default OwnerAccountBulkUploadStatementSuccess;
